export default "__VITE_ASSET__BdrVPfR2__"